/*!
 * Hello Baby Box — quick add-to-cart from product grid hover button.
 *
 * Intercepts forms with [data-hbb-quick-add], POSTs to /cart/add.js,
 * then publishes the theme's cartUpdate pub/sub event so the cart
 * drawer and bubble update without a full page reload.
 *
 * Falls back to a plain form submit if pub/sub or fetch is unavailable.
 */
(function () {
  'use strict';

  if (!('fetch' in window)) return;

  const ROUTE_ADD = '/cart/add.js';
  const ROUTE_CART = '/cart.js';

  function publishCartUpdate(cart, sourceId) {
    if (window.theme && window.theme.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.theme.PUB_SUB_EVENTS.cartUpdate, {
        source: 'hbb-quick-add',
        productVariantId: sourceId,
        cartData: cart,
      });
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer, [data-cart-drawer]');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const trigger = document.querySelector('[data-cart-toggle]');
    if (trigger) trigger.click();
  }

  function flashState(button, state, label) {
    button.dataset.state = state;
    button.disabled = state === 'loading';
    if (label) {
      if (!button.dataset.originalLabel) {
        button.dataset.originalLabel = button.textContent.trim();
      }
      button.textContent = label;
    } else if (button.dataset.originalLabel) {
      button.textContent = button.dataset.originalLabel;
    }
  }

  async function handleSubmit(event) {
    const form = event.target;
    if (!form.matches('[data-hbb-quick-add]')) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    flashState(button, 'loading', 'Duke shtuar…');

    const body = new FormData(form);
    body.set('quantity', '1');

    try {
      const response = await fetch(ROUTE_ADD, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Add to cart failed');
      }

      const cart = await fetch(ROUTE_CART).then((r) => r.json()).catch(() => null);
      publishCartUpdate(cart, idInput.value);
      flashState(button, 'success', 'U shtua ✓');
      openCartDrawer();
      window.setTimeout(() => flashState(button, 'idle'), 1800);
    } catch (error) {
      flashState(button, 'error', 'Provo përsëri');
      window.setTimeout(() => flashState(button, 'idle'), 2200);
      console.warn('[hbb-quick-add]', error);
    }
  }

  document.addEventListener('submit', handleSubmit);
})();
